import { render } from "./Sidebar.vue?vue&type=template&id=492e84ee&scoped=true&ts=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=492e84ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492e84ee"]])

export default __exports__